module.exports = __webpack_public_path__ + "static/media/Ravi Moodley.29d0046d.png";